import { render } from "./examinationBotton.vue?vue&type=template&id=f56fe3ea"
import script from "./examinationBotton.vue?vue&type=script&lang=js"
export * from "./examinationBotton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/mscode/tecs/TECS-FE-ENDUSER-NEW/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__